var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMaster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2357_63517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99996 6.57143C9.26472 6.57143 10.2781 5.55048 10.2781 4.28571C10.2781 3.02095 9.26472 2 7.99996 2C6.7352 2 5.71425 3.02095 5.71425 4.28571C5.71425 5.55048 6.7352 6.57143 7.99996 6.57143ZM7.99996 8.09524C6.22472 8.09524 2.66663 8.98667 2.66663 10.7619V12.6667H13.3333V10.7619C13.3333 8.98667 9.7752 8.09524 7.99996 8.09524Z",
    fill: "#CCCFD1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2357_63517"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMaster);
export default __webpack_public_path__ + "static/media/icon-master.3f93c966540c96048463edd2930da5b3.svg";
export { ForwardRef as ReactComponent };